/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-07-09 17:27:24
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-07-09 17:37:31
 */
import React from 'react'
import { judgeUrlMediaType, getVideoThumbnail } from '../utils/mediaUtils'

// Props 类型
interface PhotoPreviewProps {
  photo: string
  type: string
  index: number
  onClick?: (index: number) => void
}

/**
 * 照片预览组件
 * @param {object} props - 组件属性
 * @param {string} props.photo - 照片或视频URL
 * @param {string} props.type - 类型描述（用于alt文本）
 * @param {number} props.index - 索引
 * @param {function} props.onClick - 点击处理函数
 * @returns {JSX.Element} - 照片预览组件
 */
const PhotoPreview: React.FC<PhotoPreviewProps> = ({ photo, type, index, onClick }) => {
  const isVideo = judgeUrlMediaType(photo) === 'video'
  const thumbnailUrl = isVideo ? getVideoThumbnail(photo) : photo

  if (isVideo) {
    return (
      <div
        className="video-thumbnail-preview"
        onClick={(e) => {
          e.stopPropagation()
          onClick && onClick(index)
        }}
      >
        <img src={thumbnailUrl} alt={`${type}视频${index + 1}`} />
        <div className="video-play-icon-small">▶</div>
      </div>
    )
  }

  return (
    <img
      key={index}
      src={photo}
      alt={`${type}照片${index + 1}`}
      onClick={(e) => {
        e.stopPropagation()
        onClick && onClick(index)
      }}
    />
  )
}

export default PhotoPreview
